module.exports = __webpack_public_path__ + "img/CNANET.19be0df0.svg";